// extracted by mini-css-extract-plugin
export default {"negative":"Negative-module__negative--CW3iF","copilotRun":"Negative-module__copilotRun--Rdvo1"};